import { withInstall } from '@touchvue/utils';
import Ellipsis from './src/Ellipsis.vue';

export const ToEllipsis = withInstall(Ellipsis);
export default ToEllipsis;

export * from './src/ellipsis';
